import { Button } from '@/components/ui/button';
import { Row } from '@tanstack/react-table';
import { MoreHorizontal } from 'lucide-react';
import React, { useState } from 'react';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

interface DataTableRowActionsProps<TData> {
    row: Row<TData>;
    onEdit: (value: TData) => void;
    onAddPermissions: (value: TData) => void
    roles: string[]
}

const RolesRowActions = <TData,>({ row, onEdit, onAddPermissions, roles }: DataTableRowActionsProps<TData>) => {

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="flex h-8 w-8 p-0 data-[state=open]:bg-muted">
                    <MoreHorizontal className="h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {roles.includes('role-edit') && (
                    <DropdownMenuItem onClick={() => onEdit(row.original)}>Edit</DropdownMenuItem>
                )}
                {roles.includes('role-edit') && (
                    <DropdownMenuItem onClick={() => onAddPermissions(row.original)}>Assign Permissions</DropdownMenuItem>
                )}

                <DropdownMenuSeparator />
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default RolesRowActions;
